import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-500/15 text-primary-300">
        <i className="ri-live-line text-3xl" />
      </span>
      <p className="mt-6 font-heading text-5xl font-extrabold text-foreground-950">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">
        你访问的直播已下线
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        页面可能已被删除或地址拼写有误。回到首页，继续发现更多精彩的直播内容吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/channels"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/60"
        >
          <i className="ri-live-line" />
          浏览频道分类
        </Link>
      </div>
    </div>
  );
}